var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"identity"},[(_vm.isUserLoggedIn)?_c('div',{staticClass:"identity__loggedin"},[_c('Dropdown',{attrs:{"items":_vm.items,"logoutUser":_vm.logoutUser,"UserLogged":_vm.currentUser}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }